class Field {
  constructor(data) {
    this.name = data.name;
    this.displayName = data.displayName;
    this.options = data.options;
  }
}

const fields = {
  agency: new Field({
    name: 'resellerName',
    displayName: 'Agency',
  }),

  agencyProfilesAgency: new Field({
    name: 'agencyName',
    displayName: 'Partner',
  }),

  agencyProfilesTier: new Field({
    name: 'tierName',
    displayName: 'Tier',
  }),

  completeness: new Field({
    name: 'completeness',
    displayName: 'Completeness',
  }),

  integration: new Field({
    name: 'vendorName',
    displayName: 'Partners',
  }),

  rating: new Field({
    name: 'rating',
    displayName: 'Rating',
  }),

  date: new Field({
    name: 'created',
    displayName: 'Date Submitted',
  }),

  customer: new Field({
    name: 'companyName',
    displayName: 'Customer',
  }),

  integrationPartners: new Field({
    name: 'vendorName',
    displayName: 'Partner',
  }),

  projectStatus: new Field({
    name: 'projectStatus',
    displayName: 'Project Status',
  }),

  partnerAssigned: new Field({
    name: 'partnerAssigned',
    displayName: 'Assigned to partner',
  }),

  dateAssigned: new Field({
    name: 'dateAssigned',
    displayName: 'Date assigned',
  }),

  featured: new Field({
    name: 'featured',
    displayName: 'Featured',
  }),

  // Tier and Status aren't sortable because they are also filters
  tier: new Field({
    name: 'tier',
    displayName: 'Tier',
  }),

  status: new Field({
    name: 'status',
    displayName: 'Status',
  }),

  leadStatus: new Field({
    name: 'status',
    displayName: 'Lead',
  }),
};

const filters = {
  // Need to dynamically create options for tiers
  tier: new Field({
    name: 'tier',
    displayName: 'Tier',
  }),

  status: new Field({
    name: 'status',
    displayName: 'Status',
    options: {
      invited: 'Invited',
      public: 'Public',
      hidden: 'Hidden',
      pending: 'Pending',
      approved: 'Approved',
    },
  }),

  rating: new Field({
    name: 'rating',
    displayName: 'Rating',
    options: {
      one: 1,
      two: 2,
      three: 3,
      four: 4,
      five: 5,
    },
  }),
};

export const tables = {
  agencyPublicProfilesVendors: {
    fields: [
      fields.integrationPartners,
      fields.agencyProfilesTier,
      fields.status,
      fields.completeness,
    ],
    filters: [filters.tier, filters.status],
  },
  agencyProfiles: {
    fields: [
      fields.agencyProfilesAgency,
      fields.agencyProfilesTier,
      fields.status,
      fields.completeness,
    ],
    filters: [filters.tier, filters.status],
  },
  agencyProfilesFeatured: {
    fields: [
      fields.agencyProfilesAgency,
      fields.agencyProfilesTier,
      fields.status,
      fields.featured,
      fields.completeness,
    ],
    filters: [filters.tier, filters.status],
  },
  contactRequests: {
    fields: [
      fields.customer,
      fields.agency,
      fields.date,
      fields.leadStatus,
      fields.projectStatus,
    ],
    filters: [filters.status],
  },
  matchmakingRequests: {
    fields: [
      fields.customer,
      fields.date,
      fields.partnerAssigned,
      fields.dateAssigned,
      fields.status,
    ],
  },
  integrationPartners: {
    fields: [fields.integration, fields.status, fields.featured],
  },
  reviews: {
    fields: [fields.agency, fields.rating, fields.status],
    filters: [filters.rating, filters.status],
  },
  managePartners: {
    fields: [fields.integrationPartners, fields.status],
    filters: [filters.status],
  },
  leads: {
    fields: [fields.customer, fields.date, fields.status, fields.projectStatus],
    filters: [filters.status, fields.projectStatus],
  },
};
